<template>
    <div class="gs-app gs-file-assignments">
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="pricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="gs-file-assignments__panel bg-white rounded p-2 mb-2">
            <div v-for="(pricePoint, index) in localFile.price_points" :key="index">
                <div v-if="pricePointsTab ===
                    'data_sharing_product_price_point_' + pricePoint.id
                    " class="gs-file-assignments__price-point flex flex-col w-full">
                    <div class="gs-file-assignments__content flex flex-col w-full bg-white mb-2">
                        <div v-if="membership_files.length > 0">
                            <div class="gs-file-assignments__collection flex flex-col">
                                <div class="gs-file-assignments__toolbar flex flex-row-reverse w-full">
                                    <gd-button
                                        size="auto"
                                        variant="primary"
                                        class="gs-file-assignments__add mr-4"
                                        @click="showFileMembershipBox(index)"
                                    >
                                        <plus-icon class="w-5 h-5 fill-current" />
                                        {{ $t('frontend_product_step8_add_new_membership_file') }}
                                    </gd-button>
                                </div>
                                <div v-if="pricePoint.file_memberships && pricePoint.file_memberships.length > 0">
                                    <div v-for="(file, fileIndex) in pricePoint.file_memberships" :key="fileIndex"
                                        class="gs-file-assignments__row flex flex-col mt-4">
                                        <div class="gs-file-assignments__record flex flex-row" :class="{
                                            'border-t border-grey-400 border-solid pt-4':
                                                fileIndex > 0,
                                        }">
                                            <div class="gs-file-assignments__send w-1/12 mr-8">{{ $t('frontend_send') }}</div>
                                            <div class="gs-file-assignments__details-wrap flex flex-row w-11/12">
                                                <div class="gs-file-assignments__metadata w-3/4 flex flex-col">
                                                    <div class="gs-file-assignments__field flex flex-row">
                                                        <div class="gs-file-assignments__label font-bold mr-2">{{ $t('frontend_name') }}</div>
                                                        <div class="gs-file-assignments__value">
                                                            {{ fetchMemberFileName(file.file_id) }}
                                                        </div>
                                                    </div>
                                                    <div class="gs-file-assignments__field flex flex-row">
                                                        <div class="gs-file-assignments__label font-bold mr-2">
                                                            {{ $t('frontend_groovesell_file_name') }}
                                                        </div>
                                                        <div class="gs-file-assignments__value">
                                                            {{ fetchMemberOriginalFileName(file.file_id)
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="gs-file-assignments__field flex flex-row">
                                                        <div class="gs-file-assignments__label font-bold mr-2">{{ $t('frontend_size') }}</div>
                                                        <div class="gs-file-assignments__value">
                                                            {{ fetchMemberFileSize(file.file_id) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="gs-file-assignments__actions w-1/4 flex flex-row justify-end pr-4">
                                                    <gd-button size="icon" variant="primary"
                                                        :title="$t('frontend_groovesell_delete_file')"
                                                        :aria-label="$t('frontend_groovesell_delete_file')"
                                                        class="gs-file-assignments__delete mr-2"
                                                        @click="openConfirmModal(index, fileIndex)">
                                                        <trash-icon class="w-5 h-5 fill-current" />
                                                    </gd-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="mt-6">
                                    <label class="text-grey-dark">{{
                                        $t('frontend_product_step8_no_memberships_files')
                                    }}</label>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <label class="text-grey-dark">{{
                                $t('frontend_product_step8_no_memberships_files_added', {memberAppTitle: whitelabelAppData('member').title})
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirm-modal
            name="confirm-modal"
            :message-content="$t('frontend_non_revertable')"
            :button-text="$t('frontend_delete_confirm')"
            button-size="auto"
            @confirm="deleteFile"
        />
    </affiliate-workspace>
    </div>
</template>
<script>
import ConfirmModal from "../../components/AffiliateConfirmModal.vue";
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';
import PlusIcon from '@/assets/images/icons/PlusIcon.svg';

export default {
    components: { AffiliateWorkspace, ConfirmModal,
        TrashIcon,
        PlusIcon,
    },
    props: {
        pricePointsTabs: {
            type: Array,
            required: true,
        },
        pricePointsTab: {
            type: String,
            required: true,
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true,
        },
        file: {
            type: Object,
            required: true,
        },
        membership_files: {
            type: Array,
            required: true,
        },
        showFileMembershipBox: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            localFile: this.file,
            index: null,
            fileIndex: null,
        };
    },
    computed: {
        pricePointsErrorTabs() {
            return [];
        },
    },
    watch: {
        localFile: {
            handler: function (val, oldVal) {
                this.$emit('update-data', {
                    key: 'file',
                    value: val,
                });
            },
            deep: true,
        },
    },
    methods: {
        fetchMemberFileName(fileId) {
            const file = this.membership_files.find((obj) => {
                return obj.id == fileId;
            });
            return file ? file.name : 'N/A';
        },
        fetchMemberOriginalFileName(fileId) {
            const file = this.membership_files.find((obj) => {
                return obj.id == fileId;
            });
            return file ? file.original_name : 'N/A';
        },
        fetchMemberFileSize(fileId) {
            const file = this.membership_files.find((obj) => {
                return obj.id == fileId;
            });
            return file ? file.size : 'N/A';
        },
        openConfirmModal(index, fileIndex) {
            this.$root.$emit('modal-open', 'confirm-modal');
            this.index = index;
            this.fileIndex = fileIndex;
        },
        async deleteFile() {
            this.localFile.price_points[this.index].file_memberships.splice(this.fileIndex, 1);
        },
    }
}
</script>

<style scoped>
.gs-file-assignments {
    min-width: 0;
    color: var(--gs-foreground);
}

.gs-file-assignments__tabs {
    min-width: 0;
    overflow-x: auto;
    overscroll-behavior-x: contain;
}

.gs-file-assignments ::v-deep .gs-default-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 0 12px;
}

.gs-file-assignments ::v-deep .gs-default-tabs-item {
    margin-right: 0;
    min-width: 0;
    white-space: normal;
}

.gs-file-assignments ::v-deep .gs-default-tabs-item:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
}

.gs-file-assignments__panel {
    min-width: 0;
    padding: 0;
    background: var(--gs-surface);
}

.gs-file-assignments__toolbar {
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 4px;
}

.gs-file-assignments ::v-deep .gs-file-assignments__add {
    min-height: 40px;
    margin-right: 0;
    color: var(--gs-primary);
    background: var(--gs-surface);
    border: 1px solid var(--gs-primary);
    border-radius: var(--gs-radius-md);
    box-shadow: none;
}

.gs-file-assignments ::v-deep .gs-file-assignments__add:hover,
.gs-file-assignments ::v-deep .gs-file-assignments__add:focus-visible {
    color: var(--gs-primary);
    background: var(--gs-primary-soft);
}

.gs-file-assignments__row {
    min-width: 0;
}

.gs-file-assignments__record {
    display: grid;
    grid-template-columns: minmax(88px, 0.16fr) minmax(0, 1fr);
    gap: 16px;
    min-width: 0;
    padding: 16px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-file-assignments__record.border-t {
    border-top: 1px solid var(--gs-border);
}

.gs-file-assignments__send {
    width: auto;
    margin-right: 0;
    color: var(--gs-muted-foreground);
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
}

.gs-file-assignments__details-wrap {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 16px;
    width: auto;
    min-width: 0;
}

.gs-file-assignments__metadata {
    width: auto;
    min-width: 0;
    gap: 8px;
}

.gs-file-assignments__field {
    display: grid;
    grid-template-columns: minmax(112px, max-content) minmax(0, 1fr);
    gap: 8px;
    min-width: 0;
    color: var(--gs-foreground);
    font-size: 14px;
    line-height: 1.5;
}

.gs-file-assignments__label {
    margin-right: 0;
    color: var(--gs-muted-foreground);
}

.gs-file-assignments__value {
    min-width: 0;
    overflow-wrap: anywhere;
    word-break: break-word;
}

.gs-file-assignments__actions {
    width: auto;
    padding-right: 0;
    align-items: flex-start;
}

.gs-file-assignments ::v-deep .gs-file-assignments__delete {
    width: 44px;
    min-width: 44px;
    height: 44px;
    min-height: 44px;
    margin-right: 0;
    color: var(--gs-danger);
    background: transparent;
    border: 1px solid transparent;
    border-radius: var(--gs-radius-md);
    box-shadow: none;
}

.gs-file-assignments ::v-deep .gs-file-assignments__delete:hover,
.gs-file-assignments ::v-deep .gs-file-assignments__delete:focus-visible {
    color: var(--gs-danger);
    background: var(--gs-surface);
    border-color: var(--gs-danger-border);
}

.gs-file-assignments ::v-deep .gs-file-assignments__add:focus-visible,
.gs-file-assignments ::v-deep .gs-file-assignments__delete:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 3px var(--gs-ring);
}

@media (max-width: 640px) {
    .gs-file-assignments__tabs {
        margin-right: -12px;
        margin-left: -12px;
        padding-right: 12px;
        padding-left: 12px;
    }

    .gs-file-assignments__toolbar {
        display: flex;
    }

    .gs-file-assignments ::v-deep .gs-file-assignments__add {
        width: 100%;
        min-height: 44px;
        justify-content: center;
    }

    .gs-file-assignments__record,
    .gs-file-assignments__details-wrap {
        grid-template-columns: minmax(0, 1fr);
    }

    .gs-file-assignments__record {
        gap: 12px;
        padding: 14px;
    }

    .gs-file-assignments__send {
        font-size: 12px;
        letter-spacing: 0.04em;
        text-transform: uppercase;
    }

    .gs-file-assignments__field {
        grid-template-columns: minmax(0, 1fr);
        gap: 2px;
    }

    .gs-file-assignments__actions {
        justify-content: flex-start;
    }
}
</style>
